import Dashboard from './Dashboard';
export default function DashboardContributeNow() {
  return <Dashboard mode="contribute" />;
}